import CampaignIcon from '@mui/icons-material/Campaign'
import { Tooltip, Typography, useTheme } from '@mui/material'
import { GoogleAdsAccountBreakdown } from 'api/aws/analytics'

const UnlinkedAccount = ({
  googleAdsAccountsById,
  account,
}: {
  googleAdsAccountsById: Record<
    string,
    {
      name: string
      isManager: boolean
    }
  >
  account: GoogleAdsAccountBreakdown
}) => {
  const theme = useTheme()
  return (
    <>
      <CampaignIcon sx={{ fontSize: 18, color: theme.palette.warning.main }} />
      <Tooltip
        title={
          googleAdsAccountsById[account.accountId]
            ? `Google Ads Account (not linked to organization). Add Customer ID "${account.accountId}" to an organization's Integration IDs to link.`
            : `Unknown account. Add Customer ID "${account.accountId}" to an organization's Integration IDs to link.`
        }
        arrow
      >
        <Typography variant="body2" sx={{ fontWeight: 500, fontStyle: 'italic', color: 'text.disabled' }}>
          {googleAdsAccountsById[account.accountId]?.name || 'Unlinked Account'}
        </Typography>
      </Tooltip>
    </>
  )
}

export default UnlinkedAccount
